import { formatISO } from 'date-fns';
import { useGetVehiclesQuery } from '../redux/transport';
import { useCalendarDate } from './useCalendarDate';

export const useVehicleList = () => {
  const [date] = useCalendarDate(true);
  const data = useGetVehiclesQuery(formatISO(date, { representation: 'date' }));
  return data;
};
